import type { CoachingGoal } from '@efdigital/ll-addon-data';
import GoalDetail from '@efdigital/ll-xceed-v2/components/coaching/goal-detail.gts';
import type { CoachingCoachCoacheesCoacheeGoalsGoalModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/goals/goal';
import { array } from '@ember/helper';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachCoacheesCoacheeGoalsGoalSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeGoalsGoalModel;
    controller: unknown;
  };
}

export default class CoachingCoachCoacheesCoacheeGoalsGoal extends Component<CoachingCoachCoacheesCoacheeGoalsGoalSignature> {
  authorship = (goal: CoachingGoal): string =>
    goal.createdByUserId === goal.user ? 'Set by coachee' : 'You set this';

  <template>
    {{#if @model.goal}}
      {{pageTitle @model.goal.title}}

      <GoalDetail
        @goal={{@model.goal}}
        @milestones={{@model.milestones}}
        @reflections={{@model.reflections}}
        @backRoute="coaching.coach.coachees.coachee.goals"
        @backModels={{array @model.coachee.coacheeUserId}}
        @detailRoute="coaching.coach.coachees.coachee.goals.goal"
        @detailModels={{array @model.coachee.coacheeUserId @model.goal.id}}
        @refreshRoute="coaching.coach.coachees.coachee.goals"
        @role="coach"
        @authorship={{this.authorship @model.goal}}
      />
    {{/if}}
  </template>
}
